import { render, staticRenderFns } from "./NewDigitoryApp.vue?vue&type=template&id=0abb0e9d"
import script from "./NewDigitoryApp.vue?vue&type=script&lang=js"
export * from "./NewDigitoryApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports